import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import BrandclubPhoneInput, { BCPhoneInputVariant } from '../BrandclubPhoneInput/index.js';
import { styled, Grid } from '@mui/material';
import React from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import '../../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import '../../../types/filters.js';
import { getImageAssetUrl } from '../../../utils/assetUtils.js';
import '../../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import 'he';
import '../../../utils/broadcast.js';
import '../../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '../../../types/Campaign.js';
import '../../../types/product.js';
import '../../../api/graphQl/brand.js';
import '../../../api/graphQl/product.js';
import '@brandclub/types';

var Container = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: brandclub_colors.blueWhite,
        padding: 30,
        color: theme.palette.primary.main,
        fontFamily: 'Poppins',
        '.logo': {},
        '.title': {
            fontSize: 24,
            fontWeight: 700,
            paddingBottom: 3,
        },
        '.subtitle': {
            fontSize: 16,
            fontWeight: 500,
            paddingBottom: 20,
        },
    });
});
var BrandclubJoinClub = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Join the club' : _b, _c = _a.subtitle, subtitle = _c === void 0 ? 'Download the app to earn rewards.' : _c, _d = _a.containerStyle, containerStyle = _d === void 0 ? {} : _d, _e = _a.titleStyle, titleStyle = _e === void 0 ? {} : _e, _f = _a.subtitleStyle, subtitleStyle = _f === void 0 ? {} : _f, _g = _a.inputVariant, inputVariant = _g === void 0 ? BCPhoneInputVariant.DEFAULT : _g, _h = _a.brandclubPhoneInputProps, brandclubPhoneInputProps = _h === void 0 ? {} : _h, handleSendText = _a.handleSendText, userProfile = _a.userProfile;
    return (React.createElement(Container, { style: containerStyle },
        React.createElement(Grid, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 0 },
            React.createElement(Grid, { item: true, flexBasis: '100%' },
                React.createElement("div", { className: "title", style: titleStyle }, title),
                React.createElement("div", { className: "subtitle", style: subtitleStyle }, subtitle),
                React.createElement(BrandclubPhoneInput, __assign({ userProfile: userProfile, handleSendText: handleSendText, hasHeader: false, variant: inputVariant }, brandclubPhoneInputProps)),
                React.createElement("img", { src: getImageAssetUrl('brandclub-logo-wide.webp'), alt: "brandclub-text-logo", style: { width: 135, marginTop: 20, borderRadius: 0 } })))));
};

export { BrandclubJoinClub };
//# sourceMappingURL=index.js.map
